import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";

export const Navbar = () => {
  const location = useLocation();
  const onAdmin = location.pathname.startsWith("/admin");

  return (
    <header className="glass sticky top-0 z-50" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-32 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-5" data-testid="navbar-logo">
          <img
            src="/logo-mark.png"
            alt="TDstaircase"
            className="h-20 md:h-24 w-auto select-none"
            draggable={false}
          />
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-display text-3xl md:text-4xl tracking-[0.04em] text-foreground uppercase">
              TD<span className="gold-gradient-text font-semibold">STAIRCASE</span>
            </span>
            <span className="text-base uppercase tracking-[0.3em] text-muted-foreground mt-1">
              We build quality stairs
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-12 text-lg text-muted-foreground">
          <a href="/#services" className="hover:text-foreground transition-colors" data-testid="nav-services">
            Services
          </a>
          <a href="/#portfolio" className="hover:text-foreground transition-colors" data-testid="nav-portfolio">
            Portfolio
          </a>
          <a href="/#craftsmanship" className="hover:text-foreground transition-colors" data-testid="nav-craft">
            Craftsmanship
          </a>
          <a href="/#contact" className="hover:text-foreground transition-colors" data-testid="nav-contact">
            Contact
          </a>
        </nav>

        <div className="flex items-center gap-3">
          {onAdmin ? (
            <Link to="/">
              <Button variant="outline" className="rounded-none border-primary/60 text-primary hover:bg-primary/10 px-7 py-6 text-base" data-testid="back-to-site-btn">
                Back to site
              </Button>
            </Link>
          ) : (
            <Link to="/book">
              <Button
                className="rounded-none bg-primary text-primary-foreground hover:bg-accent px-8 py-6 text-base shadow-[0_0_20px_rgba(212,175,55,0.18)] hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] transition-shadow"
                data-testid="navbar-book-btn"
              >
                Book a visit
              </Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
